export const setCurrentOrg = async (service, body) => {
  const res = await service.post(`/switch`, body);
  return res;
};

export const getMappingsList = async (service) => {
  const res = await service.get(`/switch/orgs_and_groups`);
  return res;
};

export const getUser = async (service) => {
  const user = await service.get("/user/profile");
  return user;
};
